import React from 'react';
import { Divider } from 'rsuite';
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {BackIcon} from '../svg/iconsSvg';
import SignUpComponent from '../profileAndLogin/components/SignUpComponent';

const Registration = ({onBack, onForward, style}) => {

    const goBack = () => {
        onBack(9)
    }

    const goForward = () => {
        onForward(11);
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={4} steps={4} labels={steppLabels}/>
            </div>
            <Divider />
            <SignUpComponent onForward={goForward}/>
        </div>
    )
}

export default Registration;